import React from 'react'
import LayoutUI from './LayoutUI'
import LayoutHeadless from './LayoutHeadless'
import { DailyInfoMobile, DailyInfoDesktop } from '../components/widgets/DailyInfo'
import Dynamiclead from '../components/widgets/Dynamiclead'
import MobileDynamiclead from '../components/widgets/Dynamiclead/Mobile'
import Articles from '../components/widgets/Articles'
import MobileArticles from '../components/widgets/Articles/Mobile'
import TipOfTheDay from '../components/widgets/TipOfTheDay'
import Video from '../components/widgets/Video'
import MobileVideo from '../components/widgets/Video/Mobile'
import Finance from '../components/widgets/Finance'
import MobileFinance from '../components/widgets/Finance/Mobile'
import Regional from '../components/widgets/Regional'
import NewsFeed from '../components/widgets/NewsFeed'
import Email from '../components/widgets/Email'
import PromoLink from '../components/widgets/Tip/PromoLink'
import PromoVideo from '../components/widgets/Tip/PromoVideo'
import Services from '../components/widgets/Services'
import ForecastWeather from '../components/widgets/Weather/ForecastWeather'
import MobileWeather from '../components/widgets/Weather/MobileWeather'
import Jobs from '../components/widgets/Jobs'
import Exchange from '../components/widgets/Exchange'
import TvProgram from '../components/widgets/TvProgram'
import Games from '../components/widgets/Games'
import Horoscopes from '../components/widgets/Horoscopes'
import MobileHousing from '../components/widgets/Housing/Mobile'
import NativeAppPromo from '../components/widgets/NativeAppPromo'
import MobileTabs from '../components/widgets/MobileTabs'
import { LAYOUT_SECTIONS, WIDGETS } from '../constants'
import { EmailProvider } from '../context/Email'
import { HoroscopesProvider } from '../context/Horoscopes'
import { PrannotationProvider } from '../context/Prannotation'
import { SystemProvider } from '../context/System'
import MobileIconPromo from '../components/widgets/MobileIconPromo'
import MobileRegional from '../components/widgets/Regional/Mobile'
import Leaflets from '../components/widgets/Leaflets'
import MobileLeaflets from '../components/widgets/Leaflets/Mobile'
import Vareni from '../components/widgets/Vareni'
import MobileBydleni from '../components/widgets/Bydleni/Mobile'
import { WIDGET_CONTAINERS } from '../constants/layout'
import BydleniRealityContainer from '../components/containers/BydleniRealityContainer'

class Homepage extends LayoutHeadless {
  getDynamicWidgets () {
    const {
      props: {
        widgets
      },
      state: {
        containers: {
          sashec
        },
        activeDynamicLayout
      }
    } = this

    const email = <Email widget={widgets.email}/>
    const horoscopes = <Horoscopes widget={widgets.horoscopes}/>
    const tvProgram = <TvProgram widget={widgets.tvprogram}/>
    const mobileWeather = <MobileWeather widget={widgets.weather}/>

    return Object.assign({}, super.getDynamicWidgets(), {
      [WIDGETS.HOMEPAGE.DAILY_INFO_MOBILE]: () => <DailyInfoMobile/>,
      [WIDGETS.HOMEPAGE.DAILY_INFO_DESKTOP]: () => <DailyInfoDesktop widgets={widgets}/>,
      [WIDGETS.HOMEPAGE.DYNAMIC_LEAD]: () => <Dynamiclead widget={widgets.dynamiclead}/>,
      [WIDGETS.HOMEPAGE.MOBILE_DYNAMIC_LEAD]: () => <MobileDynamiclead widget={widgets.dynamiclead}/>,
      [WIDGETS.HOMEPAGE.NEWS]: () => <Articles widget={widgets.news}/>,
      [WIDGETS.HOMEPAGE.MOBILE_NEWS]: () => <MobileArticles widget={widgets.news} isOpening={true}/>,
      [WIDGETS.HOMEPAGE.TIP_OF_THE_DAY]: () => <TipOfTheDay widget={widgets.tipoftheday}/>,
      [WIDGETS.HOMEPAGE.SPORT]: () => <Articles widget={widgets.sport}/>,
      [WIDGETS.HOMEPAGE.MOBILE_SPORT]: () => <MobileArticles widget={widgets.sport} isOpening={true}/>,
      [WIDGETS.HOMEPAGE.WOMAN]: () => <Articles widget={widgets.woman}/>,
      [WIDGETS.HOMEPAGE.MOBILE_WOMAN]: () => <MobileArticles widget={widgets.woman} isOpening={true}/>,
      [WIDGETS.HOMEPAGE.VIDEO]: () => <Video widget={widgets.video}/>,
      [WIDGETS.HOMEPAGE.MOBILE_VIDEO]: () => <MobileVideo widget={widgets.video} isOpening={true}/>,
      [WIDGETS.HOMEPAGE.FINANCE]: () => <Finance widget={widgets.finance} activeDynamicLayout={activeDynamicLayout}/>,
      [WIDGETS.HOMEPAGE.CAR]: () => <Articles widget={widgets.car}/>,
      [WIDGETS.HOMEPAGE.MOBILE_CAR]: () => <MobileArticles widget={widgets.car} isOpening={true}/>,
      [WIDGETS.HOMEPAGE.REGIONAL]: () => <Regional widget={widgets.regional} activeDynamicLayout={activeDynamicLayout}/>,
      [WIDGETS.HOMEPAGE.MOBILE_REGIONAL]: () => <MobileRegional widget={widgets.regional} activeDynamicLayout={activeDynamicLayout} isOpening={true}/>,
      [WIDGETS.HOMEPAGE.MOBILE_FINANCE]: () => <MobileFinance widget={widgets.finance} isOpening={true}/>,
      [WIDGETS.HOMEPAGE.NEWS_FEED]: () => <NewsFeed widget={widgets.newsfeed} widgets={widgets} containers={{ sashec }}
        activeDynamicLayout={activeDynamicLayout}/>,
      [WIDGETS.HOMEPAGE.EMAIL]: () => email,
      [WIDGETS.HOMEPAGE.PROMO_LINK]: () => <PromoLink widget={widgets.promolink}/>,
      [WIDGETS.HOMEPAGE.PROMO_VIDEO]: () => <PromoVideo widget={widgets.promovideo}/>,
      [WIDGETS.HOMEPAGE.SERVICES]: () => <Services widget={widgets.services}/>,
      [WIDGETS.HOMEPAGE.WEATHER]: () => <ForecastWeather widget={widgets.weather}/>,
      [WIDGETS.HOMEPAGE.LEAFLETS]: () => <Leaflets widget={widgets.leaflets}/>,
      [WIDGETS.HOMEPAGE.MOBILE_LEAFLETS]: () => <MobileLeaflets widget={widgets.leaflets} activeDynamicLayout={activeDynamicLayout} isOpening={true}/>,
      [WIDGETS.HOMEPAGE.JOBS]: () => <Jobs widget={widgets.jobs}/>,
      [WIDGETS.HOMEPAGE.EXCHANGE]: () => <Exchange widget={widgets.exchange} isOpening={true}/>,
      [WIDGETS.HOMEPAGE.TV_PROGRAM]: () => tvProgram,
      [WIDGETS.HOMEPAGE.GAMES]: () => <Games widget={widgets.games}/>,
      [WIDGETS.HOMEPAGE.HOROSCOPES]: () => horoscopes,
      [WIDGETS.HOMEPAGE.MOBILE_HOUSING]: () => <MobileHousing widget={widgets.housing} activeDynamicLayout={activeDynamicLayout} isOpening={true}/>,
      [WIDGETS.HOMEPAGE.NATIVE_APP_PROMO]: () => <NativeAppPromo widget={widgets.nativeapppromo}/>,
      [WIDGETS.HOMEPAGE.MOBILE_ICON_PROMO]: () => <MobileIconPromo widget={widgets.mobileiconpromo}/>,
      [WIDGETS.HOMEPAGE.CELEBRITIES]: () => <Articles widget={widgets.celebrities}/>,
      [WIDGETS.HOMEPAGE.MOBILE_CELEBRITIES]: () => <MobileArticles widget={widgets.celebrities} isOpening={true}/>,
      [WIDGETS.HOMEPAGE.VARENI]: () => <Vareni widget={widgets.vareni}/>,
      [WIDGETS.HOMEPAGE.MOBILE_BYDLENI]: () => <MobileBydleni widget={widgets.bydleni} isOpening={true}/>,
      [WIDGETS.HOMEPAGE.MOBILE_TABS]: () => (
        <MobileTabs widget={widgets.mobiletabs}>
          {email}
          {horoscopes}
          {tvProgram}
          {mobileWeather}
        </MobileTabs>
      ),
      [WIDGET_CONTAINERS.BYDLENI_REALITY]: () => <BydleniRealityContainer bydleniWidget={widgets.bydleni} housingWidget={widgets.housing}/>
    })
  }

  getDesktopWidgetsLayout () {
    return {
      [LAYOUT_SECTIONS.TOP]: [
        WIDGETS.COMMON.LEADERBOARD
      ],
      [LAYOUT_SECTIONS.HEADER]: [
        WIDGETS.COMMON.LOGO,
        WIDGETS.COMMON.SEARCH,
        WIDGETS.COMMON.EMAIL_LINK,
        WIDGETS.COMMON.PROMO_LINK_HEADER
      ],
      [LAYOUT_SECTIONS.OVER_CONTENT]: [
        WIDGETS.HOMEPAGE.DAILY_INFO_DESKTOP
      ],
      [LAYOUT_SECTIONS.LEFT_COLUMN]: [
        WIDGETS.HOMEPAGE.DYNAMIC_LEAD,
        WIDGETS.HOMEPAGE.NEWS,
        WIDGETS.HOMEPAGE.TIP_OF_THE_DAY,
        WIDGETS.HOMEPAGE.VIDEO,
        WIDGETS.HOMEPAGE.WOMAN,
        WIDGETS.HOMEPAGE.CELEBRITIES,
        WIDGETS.HOMEPAGE.SPORT,
        WIDGET_CONTAINERS.BYDLENI_REALITY,
        WIDGETS.HOMEPAGE.FINANCE,
        WIDGETS.HOMEPAGE.CAR,
        WIDGETS.HOMEPAGE.REGIONAL,
        WIDGETS.HOMEPAGE.NEWS_FEED
      ],
      [LAYOUT_SECTIONS.RIGHT_COLUMN]: [
        WIDGETS.HOMEPAGE.EMAIL,
        WIDGETS.HOMEPAGE.PROMO_VIDEO,
        WIDGETS.HOMEPAGE.SERVICES,
        WIDGETS.COMMON.RIGHT_BANNER,
        WIDGETS.HOMEPAGE.WEATHER,
        WIDGETS.HOMEPAGE.VARENI,
        WIDGETS.HOMEPAGE.LEAFLETS,
        WIDGETS.HOMEPAGE.JOBS,
        WIDGETS.HOMEPAGE.EXCHANGE,
        WIDGETS.HOMEPAGE.TV_PROGRAM,
        WIDGETS.HOMEPAGE.GAMES,
        WIDGETS.HOMEPAGE.HOROSCOPES,
        WIDGETS.COMMON.HALF_PAGE
      ],
      [LAYOUT_SECTIONS.BOTTOM]: [],
      [LAYOUT_SECTIONS.OUTSIDE_CONTENT]: []
    }
  }

  getTabletWidgetsLayout () {
    return {
      [LAYOUT_SECTIONS.TOP]: [
        WIDGETS.COMMON.STRIP
      ],
      [LAYOUT_SECTIONS.HEADER]: [
        WIDGETS.COMMON.LOGO,
        WIDGETS.COMMON.SEARCH
      ],
      [LAYOUT_SECTIONS.OVER_CONTENT]: [],
      [LAYOUT_SECTIONS.LEFT_COLUMN]: [
        WIDGETS.HOMEPAGE.EMAIL,
        WIDGETS.HOMEPAGE.PROMO_LINK,
        WIDGETS.COMMON.PROMO_LINK_HEADER,
        WIDGETS.HOMEPAGE.DAILY_INFO_DESKTOP,
        WIDGETS.HOMEPAGE.DYNAMIC_LEAD,
        WIDGETS.COMMON.SMART_ADVERT_1,
        WIDGETS.HOMEPAGE.NEWS,
        WIDGETS.HOMEPAGE.VARENI,
        WIDGETS.HOMEPAGE.LEAFLETS,
        WIDGETS.HOMEPAGE.VIDEO,
        WIDGETS.HOMEPAGE.WOMAN,
        WIDGETS.COMMON.SMART_ADVERT_2,
        WIDGETS.HOMEPAGE.CELEBRITIES,
        WIDGETS.HOMEPAGE.SPORT,
        WIDGETS.HOMEPAGE.FINANCE,
        WIDGETS.HOMEPAGE.CAR,
        WIDGETS.HOMEPAGE.REGIONAL,
        WIDGETS.HOMEPAGE.WEATHER,
        WIDGETS.HOMEPAGE.EXCHANGE,
        WIDGET_CONTAINERS.BYDLENI_REALITY,
        WIDGETS.HOMEPAGE.TV_PROGRAM,
        WIDGETS.HOMEPAGE.JOBS,
        WIDGETS.COMMON.SMART_ADVERT_3,
        WIDGETS.HOMEPAGE.NEWS_FEED
      ],
      [LAYOUT_SECTIONS.RIGHT_COLUMN]: [],
      [LAYOUT_SECTIONS.BOTTOM]: [],
      [LAYOUT_SECTIONS.OUTSIDE_CONTENT]: []
    }
  }

  getMobileWidgetsLayout () {
    return {
      [LAYOUT_SECTIONS.TOP]: [
        WIDGETS.COMMON.STRIP
      ],
      [LAYOUT_SECTIONS.HEADER]: [
        WIDGETS.COMMON.LOGO,
        WIDGETS.COMMON.SEARCH
      ],
      [LAYOUT_SECTIONS.OVER_CONTENT]: [],
      [LAYOUT_SECTIONS.LEFT_COLUMN]: [
        WIDGETS.HOMEPAGE.DAILY_INFO_MOBILE,
        WIDGETS.HOMEPAGE.MOBILE_TABS,
        WIDGETS.COMMON.PROMO_LINK_HEADER,
        WIDGETS.HOMEPAGE.PROMO_LINK,
        WIDGETS.HOMEPAGE.MOBILE_DYNAMIC_LEAD,
        WIDGETS.COMMON.SMART_ADVERT_1,
        WIDGETS.HOMEPAGE.MOBILE_NEWS,
        WIDGETS.HOMEPAGE.MOBILE_VIDEO,
        WIDGETS.HOMEPAGE.MOBILE_WOMAN,
        WIDGETS.COMMON.SMART_ADVERT_2,
        WIDGETS.HOMEPAGE.MOBILE_CELEBRITIES,
        WIDGETS.HOMEPAGE.MOBILE_SPORT,
        WIDGETS.HOMEPAGE.EXCHANGE,
        WIDGETS.HOMEPAGE.MOBILE_FINANCE,
        WIDGETS.HOMEPAGE.MOBILE_CAR,
        WIDGETS.HOMEPAGE.MOBILE_REGIONAL,
        WIDGETS.HOMEPAGE.MOBILE_BYDLENI,
        WIDGETS.HOMEPAGE.MOBILE_HOUSING,
        WIDGETS.HOMEPAGE.VARENI,
        WIDGETS.HOMEPAGE.MOBILE_LEAFLETS,
        WIDGETS.COMMON.SMART_ADVERT_3,
        WIDGETS.HOMEPAGE.NEWS_FEED
      ],
      [LAYOUT_SECTIONS.RIGHT_COLUMN]: [],
      [LAYOUT_SECTIONS.BOTTOM]: [],
      [LAYOUT_SECTIONS.OUTSIDE_CONTENT]: [
        WIDGETS.COMMON.SMART_ADVERT_4
      ]
    }
  }

  render () {
    const {
      layout,
      widgets,
      widgets: {
        config: {
          proxyOptions
        },
        layout: {
          meta: {
            inbox: {
              requiredCookies,
              serviceUrlPattern,
              xhrLogoutUri,
              isTracked
            }
          }
        }
      }
    } = this.props

    const emailOptions = {
      proxyOptions,
      requiredCookies,
      serviceUrlPattern,
      xhrLogoutUri,
      isTracked
    }

    return (
      <SystemProvider>
        <PrannotationProvider>
          <EmailProvider options={emailOptions}>
            <HoroscopesProvider options={widgets.horoscopes}>
              <LayoutUI
                layout={layout}
                widgets={widgets}
                top={this.renderTop()}
                header={this.renderHeader()}
                overContent={this.renderOverContent()}
                leftColumn={this.renderLeftColumn()}
                rightColumn={this.renderRightColumn()}
                bottom={this.renderBottom()}
                outsideContent={this.renderOutsideContent()}
                googleAnalytics={this.googleAnalytics}
              />
            </HoroscopesProvider>
          </EmailProvider>
        </PrannotationProvider>
      </SystemProvider>
    )
  }
}

export default Homepage
